module.exports = __webpack_public_path__ + "img/Qatar.a790f391.png";